import { GenericResponse } from 'services/api/base';

export const SEASONAL_COMPARATOR_IMAGE_KEYS = [
  'firstModelImage',
  'secondModelImage',
  'differenceImage',
] as const;

export interface SeasonalComparatorImages {
  firstModelImage: string;
  secondModelImage: string;
  differenceImage: string;
}

export interface GetImagesParams {
  variable: string;
  area: string;
  confrontingModel: {
    roundDate: string;
    model: string;
    initialYearMonth: string;
    finalYearMonth: string;
  },
  baseModel: {
    roundDate: string;
    model: string;
    initialYearMonth: string;
    finalYearMonth: string;
  },
}

export interface RawGetImagesResponse {
  modelo_base: string;
  modelo_confrontante: string;
  diff: string;
}

export type GetImagesResponse = GenericResponse<RawGetImagesResponse>;
